const s = {
  detailHolder: {
    backgroundColor: 'white',
    padding: 16
  },
  detailCtn: {
    alignItems: 'center',
    marginBottom: 12
  },
  name: {
    fontSize: 14,
    fontWeight: 'bold'
  },
  highlight: {
    fontSize: 12,
    fontWeight: 'bold',
    backgroundColor: '#c9e572'
  },
  nameHighlight: {
    fontSize: 14,
    fontWeight: 'bold',
    backgroundColor: '#c9e572'
  },
  imageCtn: {
    height: 150,
    backgroundColor: '#eaeaea',
    justifyContent: 'flex-end'
  },
  image: {
    height: '90%'
  },
  actionBar: {
    height: 50,
    backgroundColor: '#fafafa',
    borderTop: '1px solid #ddd'
  },
  btnHolder: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    borderRight: '1px solid #ddd'
  }
}

export default s
